interface AdminUrlOptions {
  location?: Pick<Location, 'pathname' | 'search' | 'hash' | 'replace'>
}

export function normalizeDuplicatePathSlashes({
  location = window.location,
}: AdminUrlOptions = {}): boolean {
  const normalizedPathname = location.pathname.replace(/\/{2,}/g, '/')

  if (normalizedPathname === location.pathname) {
    return false
  }

  location.replace(`${normalizedPathname}${location.search}${location.hash}`)

  return true
}
